import { Component, HostListener, ViewChild } from '@angular/core';
import { NbMenuService, NbSidebarService, NbPopoverModule, NbPopoverDirective } from '@nebular/theme';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NbPopoverModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  logoPath = environment.logoPath;
  title = environment.title;
  subtitle = environment.subtitle;

  // private popoverRef!: NbPopoverDirective;
  @ViewChild('helpPopover') popoverRef!: NbPopoverDirective;

  // setPopover(popover: NbPopoverDirective) {
  //   this.popoverRef = popover;
  // }

  closePopover() {
    this.popoverRef?.hide();
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    this.popoverRef?.hide();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (
      target.closest('.help-btn') ||
      target.closest('.help-popover') ||
      target.closest('nb-popover')
    ) {
      return;
    }

    this.popoverRef?.hide();
  }

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
  ) { }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
